document.addEventListener('DOMContentLoaded', () => {

    function setupObserver() {
        const cookieConsent = document.querySelector('.cky-consent-container');
        const cookieOverlay = document.querySelector('.cky-overlay');

        if (cookieConsent && cookieOverlay) {
            clearInterval(checkInterval); // Stop checking for the elements
            
            const observerConfig = { attributes: true, attributeFilter: ['class'] };
            const observerCallback = (mutationsList, observer) => {
                for(let mutation of mutationsList) {
                    if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
                        checkCookieConsent(cookieConsent, cookieOverlay);
                    }
                }
            };

            const observer = new MutationObserver(observerCallback);
            observer.observe(cookieConsent, observerConfig);
            observer.observe(cookieOverlay, observerConfig);

            checkCookieConsent(cookieConsent, cookieOverlay);
        }
    }

    function checkCookieConsent(cookieConsent, cookieOverlay) {
        if (cookieConsent && cookieOverlay && (!cookieConsent.classList.contains('cky-hide') || !cookieOverlay.classList.contains('cky-hide'))) {
            document.body.classList.add('no-scroll');
        } else {
            document.body.classList.remove('no-scroll');
        }
    }

    const checkInterval = setInterval(setupObserver, 100); // Check every 100 milliseconds (1 second)
});
